import React from "react";
import { X } from "lucide-react";

interface ExportModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: string;
  onCopy: () => void;
}

export const ExportModal: React.FC<ExportModalProps> = ({
  isOpen,
  onClose,
  title,
  content,
  onCopy,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-3">
      <div className="bg-[#1a1a1a] p-4 max-w-4xl w-full mx-4 max-h-[85vh] overflow-hidden flex flex-col text-sm text-[#E6E5D3]">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-base font-semibold uppercase tracking-wider">{title}</h2>
          <button
            onClick={onClose}
            className="text-[#E6E5D3] hover:text-white"
          >
            <X size={24} />
          </button>
        </div>

        <div className="flex-1 overflow-auto mb-4">
          <pre className="text-[#E6E5D3] text-xs whitespace-pre-wrap font-mono bg-[#222] p-3">
            {content}
          </pre>
        </div>

        <div className="flex gap-2">
          <button
            onClick={onCopy}
            className="ledger-btn px-3 py-2 flex-1 uppercase tracking-wider text-xs font-semibold"
          >
            Copy to Clipboard
          </button>
          <button
            onClick={onClose}
            className="ledger-btn px-3 py-2 uppercase tracking-wider text-xs font-semibold"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};
